import React, {useCallback} from 'react';
import { strings } from 'src/localization';
import classNames from 'classnames';
import * as css from './EAppBanner.module.scss';
import { Link } from '@framework-controls/core';
import { IconAlertBell } from 'src/content/icons';

interface IProps {
    pendingItemsCount: number;
    redItems: boolean;
    link: string;
    previewFlag: string;
    theme: string;
}

const EAppBanner = (props: IProps) => {
    let iconText = props.pendingItemsCount.toString();
    let bannerFirstText = strings.formatString(strings.PendingRecommendations, props.pendingItemsCount).toString();
    // do different stuff if redItems
    if (props.redItems) {
        iconText = strings.ExclamationPoint;
        bannerFirstText = strings.CriticalRecommendations;
    }
    const mainClasses = classNames(
        css.main,
        {
            [css.mainCritical]: props.redItems,
            [css.colorSensitive]: props.theme === 'colorSensitive',
        },
    );

    const iconTextClasses = classNames(
        css.iconText,
        {
            [css.iconTextCritical]: props.redItems,
            [css.colorSensitive]: props.theme === 'colorSensitive',
        },
    );

    const messageFirstClasses = classNames(
        css.message,
        {
            [css.messageCritical]: props.redItems,
            [css.colorSensitive]: props.theme === 'colorSensitive',
        },
    );

    const messageSecondClasses = classNames(
        css.message,
        css.messageSecond,
        {
            [css.messageCritical]: props.redItems,
            [css.colorSensitive]: props.theme === 'colorSensitive',
        },
    );

    const clickHandler = useCallback(() => {
        // opens a new tab to the eApproval site.
        if (props.link && props.previewFlag !== 'p') {
            const docUrl = props.link;
            window.open(docUrl);
        }
    }, [props.link, props.previewFlag]);

    return (
        <div className={mainClasses}>
            <Link
                id='eApprovalLink'
                url={props.link}
                onClick={clickHandler}
            >
                <div className={css.bannerRows}>
                    <div className={css.row}>
                        <div className={css.alertBell}>
                            <span className={iconTextClasses}>{iconText}</span>
                            <IconAlertBell className={css.icon} />
                        </div>
                        <div className={messageFirstClasses}>{bannerFirstText}</div>
                    </div>
                    <div className={messageSecondClasses}>
                        <span>{' ' + strings.Click + ' '}</span>
                        <span className={css.underline}>{strings.Here}</span>
                        <span>{strings.ViewInspectionResults}</span>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default EAppBanner;